import RenewalService from '@/services/RenewalService'

export default {
  namespaced: true,

  state: {
    list: [],
    loading: false,
    loaded: false
  },

  mutations: {
    setRenewals(state, list) {
      state.list = Array.isArray(list) ? list : []
      state.loaded = true
    },
    setLoading(state, bool) {
      state.loading = bool
    },
    upsertRenewal(state, renewal) {
      if (!renewal || !renewal.id) return
      const idx = state.list.findIndex(r => r.id === renewal.id)
      if (idx === -1) state.list.push(renewal)
      else state.list.splice(idx, 1, { ...state.list[idx], ...renewal })
    },
    removeRenewal(state, id) {
      state.list = state.list.filter(r => r.id !== id)
    }
  },

  actions: {
    // Charge la liste une seule fois (idempotent), `force` pour rafraîchir
    fetch({ commit, state }, { force = false } = {}) {
      if (state.loaded && !force && !state.loading) return Promise.resolve(state.list)
      commit('setLoading', true)
      return RenewalService.getAll()
        .then(data => {
          const list = Array.isArray(data) ? data : (data?.results || data?.data || [])
          commit('setRenewals', list)
          return list
        })
        .catch(err => {
          console.error('[renewals] fetch error:', err)
          commit('setRenewals', [])
          return []
        })
        .finally(() => commit('setLoading', false))
    },
    create({ commit }, renewal) {
      return RenewalService.create(renewal).then(created => {
        commit('upsertRenewal', created && created.id ? created : renewal)
        return created
      })
    },
    update({ commit }, renewal) {
      return RenewalService.update(renewal).then(updated => {
        commit('upsertRenewal', updated && updated.id ? updated : renewal)
        return updated
      })
    },
    remove({ commit }, id) {
      return RenewalService.remove(id).then(res => {
        commit('removeRenewal', id)
        return res
      })
    }
  }
}
